import { render, staticRenderFns } from "./header.vue?vue&type=template&id=5fc0fd3e&scoped=true&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./header.vue?vue&type=style&index=0&lang=css&"
import style1 from "./header.vue?vue&type=style&index=1&id=5fc0fd3e&scoped=true&lang=css&"
import style2 from "./header.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc0fd3e",
  null
  
)

export default component.exports